import type { ReactNode } from "react";

import { cn } from "utils";

/**
 * The card grid every list of cards uses: events on the dashboard and on
 * browse, speakers, partners, and the skeletons that stand in for them.
 *
 * It exists for the base track. `grid sm:grid-cols-2` leaves the single-column
 * case with an implicit `auto` track, and an `auto` track is sized to its
 * items' min-content — so one unbreakable string in one card (a pasted URL, an
 * address, a long German compound) widens the column past the viewport and the
 * whole page scrolls sideways. `grid-cols-1` makes that track
 * `minmax(0, 1fr)`, which cannot exceed the container at any width.
 *
 * Callers that need a different column count at a breakpoint pass `className`;
 * the base track is not theirs to override.
 */
export function CardGrid({
  children,
  className,
  testId,
  busy,
}: {
  children: ReactNode;
  className?: string;
  testId?: string;
  /** Marks the grid as a placeholder while its real cards load. */
  busy?: boolean;
}) {
  return (
    <div
      className={cn(
        "grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3",
        className,
      )}
      data-testid={testId}
      aria-busy={busy}
    >
      {children}
    </div>
  );
}
